// extracted by mini-css-extract-plugin
module.exports = {"facebookShare":"src-components-Share-Facebook-styles-style-module__facebookShare--2q1Z5"};